import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { MainModal } from '..';
import { Button, Center, LinkGray, Title } from '../styled';
import { modalActions } from '../../store/ducks/modal';
import { appActions } from '../../store/ducks/app';

const mapStateToProps = (state: any) => ({
  cancelDowngradeModal: state.modalData.cancelDowngradeModal,
});
type StateProps = ReturnType<typeof mapStateToProps>;

interface DispatchProps {
  toggleCancelDowngradeModal: (isOpen: boolean) => void;
  cancelDowngrade: () => void;
}
type Props = StateProps & DispatchProps;

class CancelDowngradeModal extends React.Component<Props> {
  handleClose = (_event: any) => {
    this.props.toggleCancelDowngradeModal(false);
  }

  render() {
    return (
      <MainModal contentLabel="Downgrade Modal"
        isOpen={this.props.cancelDowngradeModal} close={this.handleClose}>
        <Title>
          <FormattedMessage id="cancel_downgrade_title" />
        </Title>
        <br />
        <Center>
          <Button onClick={this.props.cancelDowngrade}>
            <FormattedMessage id="yes_stay_in_premium" />
          </Button>
        </Center>
        <br />
        <Center>
          <LinkGray onClick={this.handleClose}><FormattedMessage id="no_thanks" /></LinkGray>
        </Center>
      </MainModal>
    );
  }
}

export default connect<StateProps, DispatchProps>(mapStateToProps, { ...appActions, ...modalActions })(CancelDowngradeModal);
